/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/************************
  DROP DOWN script to display filter on MAIN COLLECTION
*********************/

/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  if (event.target.className == "collection-header-toolbar-filters-btn") {
    console.log("Matched");
    var dropdowns = document.getElementsByClassName("collection-header-toolbar-filters");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('collection-header-toolbar-filters-show')) {
            console.log("Remove");

        openDropdown.classList.remove('collection-header-toolbar-filters-show');
      } else {
                    console.log("Add");
         openDropdown.classList.add('collection-header-toolbar-filters-show');
      }
    }
  }else {
    /***********************************************************
      INFO DROP DOWN  used in main product  page
    ************************************************************/
    var target = event.target;
    // Check if the clicked element or any of its parent has 'info-dropdown-btn' class
    while (target != null && !target.classList.contains('info-dropdown-btn')) {
      target = target.parentElement;
    }
  
    // If clicked inside 'info-dropdown-btn'
    if (target != null) {
      var btn = target;
      var dropdown = btn.nextElementSibling;
  
      if (dropdown.classList.contains('info-dropdown-description')) {
        if (dropdown.classList.contains('info-dropdown-description-show')) {
          dropdown.classList.remove('info-dropdown-description-show');
        } else {
          dropdown.classList.add('info-dropdown-description-show');
        }
      }
    }
  }
}



